/**
 * zod, configured for the site's content security policy. Import `z` from here, never from
 * "zod" directly (ESLint enforces it).
 *
 * zod 4 probes `new Function("")` once to decide whether it may compile fast parsers. The
 * policy has no 'unsafe-eval', so the probe always fails; zod catches that, but the browser
 * still reports a violation for every page that builds a form schema. `jitless` skips the
 * probe and uses the interpreted parsers, which are fast enough for these forms. It must be
 * set before any schema is defined: this module runs before every module that imports it.
 */
import { z } from "zod";

z.config({ jitless: true });

export { z };
